module.exports = __webpack_public_path__ + "img/logoMySQL.df5d02ac.svg";